import { ReactNode } from "react";
import { Button } from "antd";
import {
  Book, BoxArrowUpRight, ChatDots, Globe2, Instagram,
  MusicNoteBeamed, PlayCircle, Telegram, Youtube,
} from "react-bootstrap-icons";
import Scaffold from "../../components/Scaffold";
import styles from "./index.module.scss";

function ResourceLink({ label, href, icon }: { label: string; href: string; icon: ReactNode }) {
  return (
    <a href={href} target="_blank" rel="noopener noreferrer" className={styles.resourceLink}>
      <span className={styles.linkIcon} aria-hidden="true">{icon}</span>
      <span>{label}</span>
      <BoxArrowUpRight className={styles.externalIcon} aria-hidden="true" />
    </a>
  );
}

export default function SupportView() {
  return (
    <Scaffold title="Поддержка">
      <div className={styles.area}>
        <section className={styles.training} aria-labelledby="support-training">
          <div className={styles.trainingIcon} aria-hidden="true"><Book size={28} /></div>
          <h2 id="support-training">Канал с обучением работе в Flite</h2>
          <Button type="primary" href="https://t.me/+sbXTMaJAaY04OTZi" target="_blank" rel="noopener noreferrer" icon={<Telegram />}>
            ОТКРЫТЬ TELEGRAM
          </Button>
        </section>

        <div className={styles.grid}>
          <section className={styles.card} aria-labelledby="support-updates">
            <h2 id="support-updates">Каналы с обновлениями и акциями</h2>
            <ResourceLink label="Telegram" href="https://t.me/flitemobile" icon={<Telegram />} />
            <ResourceLink label="MAX" href="https://max.ru/id645123889207_biz" icon={<ChatDots />} />
          </section>

          <section className={styles.card} aria-labelledby="support-socials">
            <h2 id="support-socials">Наши соцсети</h2>
            <ResourceLink label="Instagram" href="https://www.instagram.com/flite.mobile/" icon={<Instagram />} />
            <ResourceLink label="YouTube" href="https://www.youtube.com/channel/UC6JgvazrCnqsdXZ5xDikXdw" icon={<Youtube />} />
            <ResourceLink label="Rutube" href="https://rutube.ru/channel/64745874/" icon={<PlayCircle />} />
            <ResourceLink label="TikTok" href="https://www.tiktok.com/@flite_mobile1?_r=1&_t=ZS-98p0EIVEL49" icon={<MusicNoteBeamed />} />
          </section>

          <section className={styles.card} aria-labelledby="support-contacts">
            <h2 id="support-contacts">Техподдержка</h2>
            <p className={styles.schedule}>Работает по будням с 9:00 до 18:00 МСК</p>
            <ResourceLink label="Telegram" href="https://t.me/flite_support_bot" icon={<Telegram />} />
            <ResourceLink label="MAX" href="https://max.ru/id645123889207_1_bot" icon={<ChatDots />} />
          </section>

          <section className={styles.card} aria-labelledby="support-website">
            <h2 id="support-website">Сайт</h2>
            <ResourceLink label="flite-crm.ru" href="https://flite-crm.ru/#rightsld" icon={<Globe2 />} />
          </section>
        </div>
      </div>
    </Scaffold>
  );
}
